<template>
  <div class="card_info">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="card_info_top_mbx width_center_1200">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/' }">{{ lang.all_goods }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ card_info.type }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ lang.goods_detail }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="goods_content width_center_1200">
      <div class="cont">
        <template>
          <div v-loading="loading" class="card_info_top">
            <div class="card_info_top_left">
              <div class="goods_image_item">
                <el-image :src="card_info.homeimg" fit="cover" />
              </div>
            </div>
            <div class="card_info_top_right">
              <div class="card_info_title">
                {{ card_info.name }}
                <p>{{ $t('card').validity }}：{{ card_info.endday }}{{ $t('card').day }}</p>
              </div>
              <div class="card_info_price">
                <div class="cont">
                  <!-- <div class="o-price">{{ unit }}&nbsp;{{ card_info.marketprice }}</div> -->
                  <div class="d-price">
                    <span>{{ unit }}</span>
                    &nbsp;{{ card_info.price }}
                  </div>
                </div>
              </div>
              <div class="card_info_bottom">
                <div class="card_info_btn">
                  <div class="card_info_buy" @click="handleBuy">
                    <span>{{ lang.buy }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
          </div>
          <div v-loading="loading" class="goods_detail">
            <div class="title">{{ $t('card').detail_title }}</div>
            <div class="content" v-html="card_info.destext"></div>
          </div>
          <div class="goods_notes">
            <div class="title">{{ lang.notice }}</div>
            <div class="text">{{ lang.notice_content }}</div>
          </div>
        </template>
      </div>
      <div class="recommend-goods">
        <div class="head">{{ lang.hot_sale }}</div>
        <div class="list">
          <goods-item v-for="item in goodsList" :key="item.id" :item="item" />
        </div>
      </div>
    </div>

    <div class="width_center_1200">
      <merchant-promise></merchant-promise>
    </div>

    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import GoodsItem from '../goods/components/goods'
import MerchantPromise from '@/components/MerchantPromise/index'
import { getproductlist } from '@/api/product'
import { getCardDetail } from '@/api/card'
export default {
  components: {
    ShopTop,
    ShopFoot,
    GoodsItem,
    MerchantPromise
  },
  data() {
    return {
      goodsList: [],
      card_info: {},
      loading: false
    }
  },
  computed: {
    lang() {
      return this.$t('goods_info')
    },
    ...mapGetters(['isLogin', 'location', 'unit'])
  },
  created() {
    this.getInfo(this.$route.params.card_id)
    this.getGoodsList()
  },
  methods: {
    getInfo(id) {
      this.loading = true
      getCardDetail({
        id
      }).then((res) => {
        this.loading = false
        this.card_info = res.data
      })
    },
    // 获取热卖商品
    getGoodsList() {
      getproductlist({
        ptype: 0,
        pageNum: 1,
        pageSize: 5,
        ishot: 1
      }).then(({ data }) => {
        this.goodsList = data.data
      })
    },
    // 立即购买
    async handleBuy() {
      await this.$checkLogin()
      this.$router.push({
        path: '/order/confirm',
        query: {
          id: this.card_info.id
        }
      })
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.path != from.path) {
      this.getInfo(to.params.card_id)
      this.getGoodsList()
    }
    next()
  }
}
</script>
<style lang="scss" scoped>
.card_info_top_mbx {
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
}
.goods_content {
  padding-bottom: 50px;
  .cont {
    float: left;
    width: 908px;
  }
  .recommend-goods {
    float: right;
    width: 272px;
    margin-left: 20px;
    background: #fff;
    border-radius: 12px;
    .head {
      padding: 20px;
      font-size: 18px;
      color: #4f4f4f;
      font-weight: 700;
    }
    .product {
      margin: 0 18px 20px;
      background: #ffffff;
      box-sizing: border-box;
      border-radius: 12px;
      box-shadow: 7px 7px 9px 0px #f1f4f9;
      padding: 10px 15px 10px;
      /deep/ img {
        width: 216px;
        height: 216px;
      }
      .title {
        color: #4f4f4f;
        font-size: 14px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .stock {
        padding: 4px 0 0;
        color: #aaaaaa;
        font-size: 12px;
      }
      .price {
        display: flex;
        align-items: flex-end;
        padding-bottom: 6px;
        .item-price {
          &:first-child {
            font-size: 10px;
            color: #000;
            margin-right: 10px;
            text-decoration: line-through;
          }
          font-size: 16px;
          color: #ff0000;
          span {
            font-size: 12px;
          }
        }
      }
      .bottom {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .add {
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #ec9221;
          min-width: 80px;
          padding: 0 10px;
          box-sizing: border-box;
          height: 24px;
          line-height: 24px;
          border-radius: 12px;
          color: #ffffff;
          font-size: 12px;
        }
      }
    }
    /deep/ .el-input-number__increase,
    /deep/ .el-input-number__decrease {
      top: 0;
      background: #aaa;
      border: 0;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 4px;
      font-size: 14px;
      color: #ffffff;
    }
    /deep/ .el-input-number--small {
      width: 74px;
      line-height: 24px;
    }
    /deep/ .el-input-number {
      .el-input {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .el-input__inner {
        padding: 0;
        width: 28px;
        height: 20px;
        line-height: 20px;
        border: 1px solid #aaa;
        color: #000;
        font-size: 12px;
      }
    }
  }
}
.card_info_top {
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  padding: 32px;
  min-height: 120px;
}
.card_info_top_left {
  width: 260px;
  margin-right: 30px;
  float: left;
  box-sizing: border-box;
  .goods_image_item {
    width: 260px;
    height: 115px;
    display: block;
    /deep/ .el-image {
      width: 100%;
      height: 100%;
    }
  }
}
.card_info_top_right {
  float: left;
  width: 554px;
  font-size: 14px;
  background: #fff;
  .card_info_title {
    position: relative;
    font-size: 18px;
    color: #4f4f4f;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
    p {
      color: #4f4f4f;
      font-size: 12px;
      padding: 8px 0 15px;
    }
  }

  .card_info_label {
    display: inline-block;
    width: 478px;
    height: 50px;
    line-height: 50px;
    margin-bottom: 24px;
    background-image: linear-gradient(112deg, #e17d00, #d18320);
    span {
      padding-left: 50px;
      font-size: 16px;
      color: #fff;
    }
  }
  .card_info_price {
    display: flex;
    justify-content: space-between;
    .cont {
      flex: 1;
      display: flex;
      align-items: center;
    }
    .o-price {
      color: #4f4f4f;
      font-size: 14px;
      text-decoration: line-through;
      padding-right: 20px;
    }
    .d-price {
      color: #ff0000;
      font-weight: 700;
      font-size: 20px;
      span {
        font-weight: 400;
        font-size: 14px;
      }
    }
    .item-tag {
      text-align: center;
      padding: 0 8px;
      height: 18px;
      line-height: 18px;
      background: #ff0000;
      border-radius: 4px;
      font-size: 12px;
      color: #ffffff;
      margin-left: 10px;
      margin-bottom: 4px;
    }
    .stock {
      color: #4f4f4f;
      font-size: 12px;
    }
  }
  .card_info_btn {
    display: flex;
  }
  .card_info_bottom {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
  .card_info_add_cart,
  .card_info_buy {
    text-align: center;
    width: 136px;
    line-height: 40px;
    margin-right: 15px;
    background: #ffd39b;
    border-radius: 6px;
    font-size: 16px;
    color: #ef8500;
    cursor: pointer;
    font-weight: 700;
    &.end {
      background: #aaa;
      color: #fff;
    }
  }
  .card_info_add_cart {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 185px;
    background: #ef8500;
    color: #fff;
    font-size: 16px;
    .svg-icon {
      margin-right: 10px;
    }
  }
  .card_info_action {
    display: flex;
    align-items: center;
    .action {
      position: relative;
      margin-left: 20px;
      &:first-child {
        &:hover .share-box {
          display: block;
        }
      }
      .share-box {
        display: none;
        position: absolute;
        left: -100%;
        border: 1px solid #efeff1;
        border-radius: 4px;
        text-align: center;
        .el-image {
          display: flex;
          width: 85px;
          height: 85px;
        }
        span {
          display: block;
          margin-top: -2px;
          padding-bottom: 4px;
          font-size: 12px;
          color: #4f4f4f;
        }
      }
      .svg-icon {
        width: 25px;
        height: 25px;
        cursor: pointer;
      }
    }
  }
}
.goods_detail {
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 20px;
  .title {
    height: 40px;
    line-height: 40px;
    background: #ec9221;
    padding: 0 15px;
    font-size: 16px;
    color: #fff;
    margin-bottom: 15px;
  }
  /deep/ .content {
    img {
      display: flex;
      width: 100%;
      margin: 0 auto;
    }
  }
}
.goods_notes {
  padding: 30px;
  background: #fff;
  border-radius: 12px;
  margin-bottom: 160px;
  .title {
    font-size: 16px;
    font-weight: 400;
    color: #4f4f4f;
    text-align: center;
    padding-bottom: 10px;
  }
  .text {
    font-size: 14px;
    font-weight: 400;
    color: #4f4f4f;
    padding-bottom: 16px;
  }
}
</style>